module.exports = __webpack_public_path__ + "img/Warrior-nightelf-f-70.71409754.gif";